import type { Route } from "nextjs-routes";

import config from "configs/app";

const CANONICAL_ROUTES: Array<Route["pathname"]> = [
  "/",
  "/txs",
  "/ops",
  "/verified-contracts",
  "/name-domains",
  "/withdrawals",
  "/tokens",
  "/stats",
  "/api-docs",
  "/gas-tracker",
  "/apps",
  "/references",
];

export default function getCanonicalUrl(pathname: Route["pathname"]) {
  if (CANONICAL_ROUTES.includes(pathname)) {
    // 根路径不添加 /，其他路径正常拼接
    if (pathname === "/") {
      return config.app.baseUrl;
    }
    return config.app.baseUrl + pathname;
  }
}
